export default function ProductName(props: {
    productName: string
}){
    return (
        <div className="absolute bottom-8 bg-white text-primary w-full font-bold text-[22px] text-center py-2">
            {props.productName}
        </div>
    )
}